import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { CommunityAbout, CommunityHeader, CommunityLayout } from 'features/communities-new';
import { ChangeRequestLogoutGuard } from '../change-request-logout-guard';
import { useCommunityInvitationTokenParams, useCommunityTabNavigation } from '../hooks';

export type RouteParams = {
  communityId: string;
};

const PageCommunityAbout = () => {
  const { communityId } = useRequiredParams<RouteParams>();
  const { invitationToken } = useCommunityInvitationTokenParams();
  const { onNavigateToCommunityTab } = useCommunityTabNavigation(communityId);

  return (
    <AppLayout>
      <ChangeRequestLogoutGuard>
        <CommunityLayout
          communityId={communityId}
          header={(community) => (
            <CommunityHeader
              activeTab="/about"
              community={community}
              isPublicView={false}
              onNavigateToCommunityTab={onNavigateToCommunityTab}
            />
          )}
          invitationToken={invitationToken}
        >
          {(community) => <CommunityAbout community={community} />}
        </CommunityLayout>
      </ChangeRequestLogoutGuard>
    </AppLayout>
  );
};

export default PageCommunityAbout;
